/*@ngInject*/
const FormActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function (uri) {
        var url = '/rest/Actions',
            config = {
                params: {
                    uri: uri
                }
            };

        return this.get(url, config);
    };
};

angular.module('ums.configuration')
    .service('formActionRepository', FormActionRepository);
